//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'echarts-liquidfill/src/liquidFill.js'; // 引入提示框

require('echarts/lib/component/tooltip'); // 引入标题组件


require('echarts/lib/component/title');

require('echarts/lib/component/legendScroll');

import { getAction } from '@/api/manage'; // 日期格式化插件

import moment from 'moment';
import { queryRealtime as _queryRealtime, querySiteList as _querySiteList } from '@/api/api';
import screenfull from 'screenfull';
var dateTimer;
var timer;
export default {
  data: function data() {
    return {
      headDate: '',
      headWeek: '',
      headTime: '',
      isFullscreen: false,
      dataMap3: {},
      dataMap2: {},
      dataMap: {},
      remark: '',
      imgSrc: '',
      remark2: '',
      imgSrc2: '',
      remark3: '',
      imgSrc3: ''
    };
  },
  mounted: function mounted() {
    moment.locale('zh-cn');
  },
  methods: {
    initData: function initData() {
      var _this = this;

      dateTimer = setInterval(function () {
        var date = new Date();
        _this.headDate = moment(date).format('YYYY年MM月DD日');
        _this.headWeek = moment(date).format('dddd');
      }, 60000);
      this.getDate();
      this.queryRealtime(10);
      this.queryRealtime(9);
      this.queryRealtime(11);
      this.querySiteList(10);
      this.querySiteList(9);
      this.querySiteList(11);
    },
    clearTimer: function clearTimer() {
      clearInterval(dateTimer);
      clearInterval(timer);
    },
    toData: function toData() {
      this.$router.push('/ds/index');
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    getDate: function getDate() {
      var _this2 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headWeek = moment(date).format('dddd');
      this.headTime = moment(date).format('HH:mm:ss');
      timer = setInterval(function () {
        var time = new Date();
        _this2.headTime = moment(time).format('HH:mm:ss');

        _this2.$forceUpdate();
      }, 1000);
    },
    // 获取表数据
    queryRealtime: function queryRealtime(id) {
      var _this3 = this;

      var that = this;
      var params = {
        type: 1,
        id: id
      }; // 污水站点

      _queryRealtime(params).then(function (res) {
        if (res) {
          console.log(res.result.records[0].dataMap, id);

          if (id == 10) {
            _this3.dataMap = res.result.records[0].dataMap;
          }

          if (id == 9) {
            _this3.dataMap2 = res.result.records[0].dataMap;
          }

          if (id == 11) {
            _this3.dataMap3 = res.result.records[0].dataMap;
          }
        }
      });
    },
    querySiteList: function querySiteList(id) {
      var _this4 = this;

      var that = this; // 污水站点

      _querySiteList({
        id: id
      }).then(function (res) {
        if (res) {
          if (id == 10) {
            _this4.remark = res.result.records[0].remark;
            _this4.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }

          if (id == 9) {
            _this4.remark2 = res.result.records[0].remark;
            _this4.imgSrc2 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }

          if (id == 11) {
            _this4.remark3 = res.result.records[0].remark;
            _this4.imgSrc3 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }
        }
      });
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    }
  }
};